









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Portals extends Vue {
  @Prop()
  private readonly images!: string[];
}
